import { getState } from 'live/redux/selectors/index.shared';
import get from 'lodash/get';
import { createSelector } from 'reselect';

const getUiState = createSelector(getState, state => get(state, 'ui'));

export const getSection = createSelector(getUiState, state =>
  get(state, 'section'),
);
